import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-top-image-rotator',
    imports: [
        CommonModule
    ],
    templateUrl: './top-image-rotator.component.html',
    styleUrl: './top-image-rotator.component.scss'
})
export class TopImageRotatorComponent {

    @Input('pageBgList') pageBgList : string[] = [] ;
    public activeIndex: number = 0 
    private timeoutId : any

    constructor() {
        this.loop()
    }

    ngOnDestroy() {
        clearTimeout(this.timeoutId)
    }

    loop() {
        if(this.pageBgList.length == 1) return
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
            this.next()
            this.loop()
        }, 5000);
    }

    next() {
        if(this.activeIndex < this.pageBgList.length-1 ) {
            this.activeIndex++
        }
        else {
            this.activeIndex = 0
        }
    }
}
